/**
 * WordPress dependencies
 */
import domReady from '@wordpress/dom-ready';

domReady(() => {
	const donationData = JSON.parse(localStorage.getItem('profundo_donation_data')) || [];

	//window.dataLayer = window.dataLayer || [];

	if (!window.dataLayer) {
		return;
	}

	if (!donationData || !donationData['datetime']) {
		return;
	}

	const donationTimestamp = new Date(donationData['datetime']);
	const currentTimestamp = new Date();
	const difference = currentTimestamp - donationTimestamp;

	// We are within one hour of this data being set.
	if (difference < ( 60 * 60 * 1000 )) {
		const newDataLayer = {
			'event': 'donation',
			'uuid': donationData['uuid'],
			'recurring': 'single' === donationData['recurring'] ? 0 : 1, // 0 == once / 1 == recurring
			'payment_method': donationData['payment_method'],
			'value': donationData['value'],
		}

		localStorage.removeItem('profundo_donation_data');
		window.dataLayer.push( newDataLayer );
	}
});
